import { generateTestId } from "@client-shared";

export const setOrdersByProductChartTestId = (identifier: string): string =>
  generateTestId("OrdersByProductChart", identifier);

// Specific testId setters for tests
export const setOrdersByProductChartContainerTestId = (): string =>
  setOrdersByProductChartTestId("container");
export const setOrdersByProductChartTitleTestId = (): string =>
  setOrdersByProductChartTestId("title");
